import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

interface FormatOption {
  value: number; // battleMode: 0 singles, 1 doubles
  label: string;
}

@Component({
  selector: 'app-format-segment',
  imports: [],
  templateUrl: './format-segment.component.html',
  styleUrls: ['./format-segment.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormatSegmentComponent {
  readonly value = input.required<number>();
  readonly compact = input<boolean>(false); // tighter padding/font for dense rows
  readonly disabled = input<boolean>(false);
  readonly valueChange = output<number>();

  readonly options: readonly FormatOption[] = [
    { value: 0, label: 'Singles' },
    { value: 1, label: 'Doubles' },
  ];

  select(opt: FormatOption): void {
    if (opt.value !== this.value()) this.valueChange.emit(opt.value);
  }
}
